export const projects = [
    {
        key: 'nura',
        title: 'Nura',
        avatar: 'nura.png',
        markdown: true,
        pinned: false,
        status: 'active',
        github: null,
        demo: null,
        logos: ['TypeScript', 'PostgreSQL', 'Supabase', 'Expo', 'React'],
        messages: [],
    },
    {
        key: 'pim',
        title: 'PIM Sprey',
        avatar: 'pim.png',
        markdown: true,
        pinned: false,
        status: 'active',
        github: null,
        demo: null,
        logos: ['TypeScript', 'PostgreSQL', 'Sequelize', 'Redis', 'Elasticsearch', 'Docker'],
        messages: [],
    },
    {
        key: 'preppy',
        title: 'Preppy sport',
        avatar: 'preppy.webp',
        markdown: true,
        github: null,
        demo: null,
        logos: ['React', 'NodeJS', 'Strapi', 'Expo'],
        messages: [],
    },
    {
        key: 'graal',
        title: 'Graal',
        avatar: 'graal.png',
        markdown: true,
        github: null,
        demo: null,
        logos: ['Symfony', "PHP", "Doctrine", "MySQL", "RabbitMQ"],
        messages: [],
    },
    {
        key: 'expandia',
        title: 'Expandia',
        avatar: 'logo_expandia.svg',
        markdown: true,
        github: null,
        demo: null,
        logos: ['NodeJS', 'ThreeJS'],
        messages: [],
    },
    {
        key: 'syncodeo',
        title: 'Syncodeo',
        avatar: 'logo_syncodeo.svg',
        markdown: true,
        pinned: false,
        github: null,
        demo: null,
        logos: ['React', 'AntDesign', 'Hapi', 'MySQL', 'Elasticsearch', 'Redis', 'Google', 'YouTube', 'Grafana', 'Prometheus'],
        messages: [],
    },
    {
        key: 'gogoresto',
        title: 'Gogoresto',
        avatar: 'gogoresto.png',
        markdown: true,
        github: null,
        demo: null,
        logos: ['AndroidStudio', 'Java'],
        messages: [],
    },
    {
        key: 'zestfully',
        title: 'Zestfully',
        avatar: 'zestfully.png',
        markdown: true,
        pinned: false,
        github: null,
        demo: null,
        logos: ['NuxtJS', 'PostgreSQL', 'Elasticsearch'],
        carousel: ['image1.png', 'image2.png', 'image3.png', 'image4.png', 'image5.png', 'image6.png'],
        messages: [],
    },
    {
        key: 'game_jam',
        title: 'Gamejam',
        avatar: 'gamejam.gif',
        github: null,
        demo: null,
        logos: ['Unity', 'CSharp'],
        messages: [],
    },
    {
        key: 'esdi',
        title: 'ESDI',
        avatar: 'esdi.png',
        github: null,
        demo: null,
        logos: ['Unity', 'CSharp'],
        messages: [],
    },
    {
        key: 'havas-voyages',
        title: 'Havas Voyages',
        avatar: 'havas-voyages.jpeg',
        markdown: true,
        github: null,
        demo: null,
        logos: ['WordPress', 'PHP', 'MySQL', 'JavaScript'],
        messages: [],
    },
    {
        key: 'bretzel_games',
        title: 'Bretzel Games',
        avatar: 'bretzel-games.png',
        github: null,
        demo: null,
        logos: ['VueJS', 'NodeJS', 'SocketIO'],
        messages: [],
    },
    {
        key: 'playdate_snake',
        title: 'Snake',
        avatar: 'snake.jpeg',
        github: null,
        demo: null,
        logos: ['Lua'],
        messages: [],
    },
    {
        key: 'qrun',
        title: 'QR Code',
        avatar: 'qrcode.png',
        github: null,
        demo: null,
        logos: ['AndroidStudio', 'Java'],
        messages: [],
    }
];

export const user = {
    id: 1,
    nickname: 'Giovanni',
    avatarColor: 'rgb(37, 128, 205)'
};
